import Vue from 'vue';

export const device = () => {
  if (Vue.prototype.$device.ios) {
    // return window.app;
    return window.webkit.messageHandlers;
  } else if (Vue.prototype.$device.android) {
    return window.app;
  }
  return window;
};

export const isIos = () => Vue.prototype.$device.ios; // false

export const isAndroid = () => Vue.prototype.$device.android;

// biz method
export const getAppToken = () => {
  let result = null;
  try {
    if (isIos()) {
      // result = device().getToken.postMessage(null);
      /* eslint-disable no-alert */
      result = window.prompt('getToken', '');
      /* eslint-disable no-alert */
    } else if (isAndroid) {
      result = device().getToken();
    }
  } catch (ex) {
    //
  }
  return result;
};

export const getUnreadMsgCount = (jsonGroupIds) => {
  let result = {};
  try {
    if (isIos()) {
      // result = device().getUnreadMsgCount.postMessage(jsonGroupIds);
      /* eslint-disable no-alert */
      result = JSON.parse(window.prompt('getUnreadMsgCount', jsonGroupIds));
      /* eslint-disable no-alert */
    } else if (isAndroid) {
      result = JSON.parse(device().getUnreadMsgCount(jsonGroupIds));
    }
  } catch (ex) {
    //
  }
  return result;
};

export const getLocation = () => {
  let result = { latitude: '39.90', longitude: '116.38' };
  try {
    if (isIos()) {
      device().getLocation.postMessage('setLocation');
    } else if (isAndroid) {
      result = JSON.parse(device().getLocation());
    }
  } catch (ex) {
    //
  }
  return result;
};

export const toLogin = () => {
  try {
    if (isIos()) {
      device().toLogin.postMessage(null);
    } else if (isAndroid) {
      device().toLogin();
    }
  } catch (ex) {
    //
  }
};

export const toGaodeMap = (address, latitude, longitude, methodName) => {
  try {
    if (isIos()) {
      device().toGaodeMap.postMessage([address, latitude, longitude, methodName]);
    } else if (isAndroid) {
      device().toGaodeMap(address, latitude, longitude, methodName);
    }
  } catch (ex) {
    //
  }
};

export const toConversation = () => {
  try {
    if (isIos()) {
      device().toConversation.postMessage(null);
    } else if (isAndroid) {
      device().toConversation();
    }
  } catch (ex) {
    //
  }
};

export const toGroupConversation = (groupId) => {
  try {
    if (isIos()) {
      device().toGroupConversation.postMessage(groupId);
    } else if (isAndroid) {
      device().toGroupConversation(groupId);
    }
  } catch (ex) {
    //
  }
};

export const toWorkLog = (groupId, workLog) => {
  try {
    if (isIos()) {
      device().toWorkLog.postMessage([groupId, workLog]);
    } else if (isAndroid) {
      device().toWorkLog(groupId, workLog);
    }
  } catch (ex) {
    //
  }
};

export const toStartWork = (projectId, isSignedContract) => {
  try {
    if (isIos()) {
      device().toStartWork.postMessage([projectId, isSignedContract]);
    } else if (isAndroid) {
      device().toStartWork(projectId, isSignedContract);
    }
  } catch (ex) {
    //
  }
};

export const toPersonalDetail = (personType, userId) => {
  try {
    if (isIos()) {
      device().toPersonalDetail.postMessage([personType, userId]);
    } else if (isAndroid) {
      device().toPersonalDetail(personType, userId);
    }
  } catch (ex) {
    //
  }
};

export const toTeamDetail = (teamId) => {
  try {
    if (isIos()) {
      device().toTeamDetail.postMessage(teamId);
    } else if (isAndroid) {
      device().toTeamDetail(teamId);
    }
  } catch (ex) {
    //
  }
};

export const toAttendance = (projectId) => {
  try {
    if (isIos()) {
      device().toAttendance.postMessage(projectId);
    } else if (isAndroid) {
      device().toAttendance(projectId);
    }
  } catch (ex) {
    //
  }
};



// WEBPACK FOOTER //
// ./src/util/native.js